import api from '../../api'

const {forEachSeries} = require('p-iteration')

import {
    SET_APPRAISALREPORT_REALESTATES,
    SET_TEMP_APPRAISALREPORT_REALESTATES
} from '../../constants'

const default_state = {
    realestates: {},
    temp_realestates: {}
}
const state = default_state

const actions = {
    FETCH_APPRAISALREPORT_REALESTATES: ({state, commit, rootState}, data) => {

        // console.log('data.path (fetch_appraisalreport_realestates) ---->')
        // console.log(data.path)
        return new Promise((resolve, reject) => {
            let realestates = null

            api.get({path: data.path})
                .then((res) => {
                    // console.log(res)
                    realestates = res
                    console.log('realestates: ')
                    console.log(realestates)

                    let realestate_counter = 0
                    let realestates_size = _.size(realestates)

                    if (_.size(realestates) > 0) {

                        forEachSeries(_.values(realestates), (realestate) => {
                            realestate_counter++
                            console.log('forEachSeries realestate: ')
                            console.log(realestate)

                            let realestate_id = realestate.id
                            // let realestate_index = realestate.index
                            //
                            // if (!realestate_index) {
                            //     realestate_index = 0
                            // }



                                api.get({path: 'realestate_appraisals' + '/' + realestate.id})
                                    .then((res) => {
                                        let appraisals = res

                                        let appraisal_counter = 0
                                        let appraisals_size = _.size(appraisals)

                                        forEachSeries(_.values(appraisals), (appraisal) => {
                                            appraisal_counter++
                                            // console.log('forEachSeries appraisal: ')
                                            // console.log(appraisal)

                                            let appraisal_id = appraisal.id
                                            // console.log('appraisal_id: ')
                                            // console.log(appraisal_id)

                                            let obj = {}
                                            obj['appraisaldate'] = appraisal.appraisaldate
                                            obj['id'] = appraisal.id

                                            if (appraisal.realestate_total_adopted_value) {
                                                obj['realestate_total_adopted_value'] = appraisal.realestate_total_adopted_value
                                            } else {
                                                obj['realestate_total_adopted_value'] = null
                                            }

                                            // console.log('>>>> obj: ')
                                            // console.log(obj)

                                            api.set_value({
                                                value: obj,
                                                path: 'appraisalreports' + '/' + data.appraisalreport_id + '/' + 'realestates' + '/' + realestate_id + '/' + 'appraisals' + '/' + appraisal_id,
                                                save_timestamp: false
                                            }).then(() => {

                                                    if (realestate.appraisal_id === appraisal_id) {
                                                        api.set_value({
                                                            value: obj['id'],
                                                            path: 'appraisalreports' + '/' + data.appraisalreport_id + '/' + 'realestates' + '/' + realestate_id + '/' + 'appraisal_id',
                                                            save_timestamp: false
                                                        }).then(() => {
                                                            api.set_value({
                                                                value: obj['appraisaldate'],
                                                                path: 'appraisalreports' + '/' + data.appraisalreport_id + '/' + 'realestates' + '/' + realestate_id + '/' + 'appraisaldate',
                                                                save_timestamp: false
                                                            }).then(() => {
                                                                api.set_value({
                                                                    value: obj['realestate_total_adopted_value'],
                                                                    path: 'appraisalreports' + '/' + data.appraisalreport_id + '/' + 'realestates' + '/' + realestate_id + '/' + 'realestate_total_adopted_value',
                                                                    save_timestamp: false
                                                                }).then(() => {
                                                                    realestates[realestate_id]['appraisal_id'] = obj['id']
                                                                    realestates[realestate_id]['appraisaldate'] = obj['appraisaldate']
                                                                    realestates[realestate_id]['realestate_total_adopted_value'] = obj['realestate_total_adopted_value']

                                                                    console.log('yup')

                                                                    console.log('realestate_counter: ' + realestate_counter + ' realestate_total: ' + realestates_size)
                                                                    console.log('appraisal_counter: ' + appraisal_counter + ' appraisal_total: ' + appraisals_size)

                                                                    if (appraisal_counter => appraisals_size) {
                                                                        if (realestate_counter => realestates_size) {
                                                                            commit(SET_APPRAISALREPORT_REALESTATES, realestates)
                                                                            resolve()
                                                                        }
                                                                    }
                                                                })
                                                            })

                                                        })

                                                    }
                                                    else {
                                                        console.log('nope')

                                                        console.log('realestate_counter: ' + realestate_counter + ' realestate_total: ' + realestates_size)
                                                        console.log('appraisal_counter: ' + appraisal_counter + ' appraisal_total: ' + appraisals_size)

                                                        if (appraisal_counter => appraisals_size) {
                                                            if (realestate_counter => realestates_size) {
                                                                commit(SET_APPRAISALREPORT_REALESTATES, realestates)
                                                                resolve()
                                                            }
                                                        }

                                                    }

                                                }
                                            )

                                        })

                                    })

                        })

                        /*
                        _.forEach(realestates, (value, key) => {
                            let realestate_id = value['id']

                            // console.log('>> realestate:')
                            // console.log(value)

                            api.get({path: 'realestate_appraisals' + '/' + value['id']})
                                .then((res) => {
                                    let appraisals = res
                                    _.forEach(appraisals, (value2, key2) => {

                                        let appraisal_id = value2['id']
                                        let obj = {}
                                        obj['appraisaldate'] = value2['appraisaldate']
                                        obj['id'] = value2['id']

                                        if (value2['realestate_total_adopted_value']) {
                                            obj['realestate_total_adopted_value'] = value2['realestate_total_adopted_value']
                                        } else {
                                            obj['realestate_total_adopted_value'] = null
                                        }


                                        // console.log('>>>> obj: ')
                                        // console.log(obj)

                                        api.set_value({
                                            value: obj,
                                            path: 'appraisalreports' + '/' + data.appraisalreport_id + '/' + 'realestates' + '/' + realestate_id + '/' + 'appraisals' + '/' + appraisal_id,
                                            save_timestamp: false
                                        })

                                        realestates[realestate_id]['appraisals'][appraisal_id] = obj

                                        if(value['appraisal_id'] === appraisal_id){
                                            api.set_value({
                                                value: obj['id'],
                                                path: 'appraisalreports' + '/' + data.appraisalreport_id + '/' + 'realestates' + '/' + realestate_id + '/' + 'appraisal_id',
                                                save_timestamp: false
                                            })
                                            api.set_value({
                                                value: obj['appraisaldate'],
                                                path: 'appraisalreports' + '/' + data.appraisalreport_id + '/' + 'realestates' + '/' + realestate_id + '/' + 'appraisaldate',
                                                save_timestamp: false
                                            })
                                            api.set_value({
                                                value: obj['realestate_total_adopted_value'],
                                                path: 'appraisalreports' + '/' + data.appraisalreport_id + '/' + 'realestates' + '/' + realestate_id + '/' + 'realestate_total_adopted_value',
                                                save_timestamp: false
                                            })

                                            realestates[realestate_id]['appraisal_id'] = obj['id']
                                            realestates[realestate_id]['appraisaldate'] = obj['appraisaldate']
                                            realestates[realestate_id]['realestate_total_adopted_value'] = obj['realestate_total_adopted_value']
                                        }



                                    })

                                })

                        })

                        */

                        // console.log('****** realestates: ')
                        // console.log(realestates)

                    } else {
                        console.log('realestates size is 0')
                        commit(SET_APPRAISALREPORT_REALESTATES, null)
                        resolve()
                    }
                })
        })
    },
    FETCH_TEMP_APPRAISALREPORT_REALESTATES: ({state, commit, rootState}, data) => {

        // console.log('data.path (fetch_appraisalreport_realestates) ---->')
        // console.log(data.path)
        return new Promise((resolve, reject) => {
            let realestates = null

            api.get({path: data.path})
                .then((res) => {
                    // console.log(res)
                    realestates = res
                    // console.log('realestates: ')
                    // console.log(realestates)

                    commit(SET_TEMP_APPRAISALREPORT_REALESTATES, realestates)
                    resolve()
                    // console.log('****** realestates: ')
                    // console.log(realestates)

                })
        })
    }
}

const mutations = {
    [SET_APPRAISALREPORT_REALESTATES] (state, data) {
        state.realestates = data
    },
    [SET_TEMP_APPRAISALREPORT_REALESTATES] (state, data) {
        state.temp_realestates = data
    }
}

const getters = {
    appraisalreport_realestates: state => {
        return state.realestates
    },
    temp_realestates: state => {
        return state.temp_realestates
    }
}

export default {
    state,
    actions,
    mutations,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/appraisalreport/appraisalreport_realestates.js